<div class="flex-col page">
  <nav>
    <div class="nav-content">
      <div class="logo">
        <!-- <img src="/assets/temp_logo.png" /> -->
      </div>
    </div>
  </nav>

  <div class="flex-row">
    <div class="side">
      <div>
        <div>Teams</div>
        <div class="team-size-selector">
          <div (click)="removeTeam()" class="btn">-</div>
          <div class="total">{{ teams }}</div>
          <div (click)="addTeam()" class="btn">+</div>
        </div>
      </div>
    </div>
    <drag-scroll scrollbar-hidden="true" class="content">
      <lib-bracket [teams]="teams"></lib-bracket>
    </drag-scroll>
  </div>
</div>
